var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"watermark-text"},[_c('div',{staticClass:"watermark-text__top"},[_vm._v(" "+_vm._s(_vm.watermarkParams.text[0])+" ")]),_c('div',{staticClass:"watermark-text__user"},[_vm._v(" "+_vm._s(_vm.watermarkParams.text[1])+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }